import * as React from 'react';
import * as classNames from 'classnames';
import isFunction = require('lodash/isFunction');
import {Component, ReactElement, ChangeEvent} from 'react';
import {BubbleError} from '../bubble-error/bubble-error';
import './styles.sass';

export interface ISelectOption {
  value: string;
  label: string;
}

interface ISelectProps {
  placeholder?: string;
  transparent?: boolean;
  reference?: FunctionalReference;
  disabled?: boolean;
  options: Array<ISelectOption>;
  focused?: boolean;
  label?: string;
  value?: string;
  error?: string;
  onChange?: (value: ISelectOption) => void;
  onFocus?: () => void;
}

interface ISelectState {
  value: string;
}

export class Select extends Component<ISelectProps, ISelectState> {

  public static defaultProps: ISelectProps = {
    placeholder: '',
    reference: null,
    disabled: false,
    options: [],
    focused: false,
    value: '',
    error: '',
  };

  public state: ISelectState = {
    value: '',
  };

  private ref: HTMLElement;

  public constructor (props: ISelectProps) {
    super(props);

    this.state = {
      value: this.props.value,
    };
  }

  public componentDidMount(): void {
    this.props.focused
      && this.ref.focus();
  }

  public render(): ReactElement<{}> {
    const {value} = this.state;
    const {
      placeholder,
      transparent,
      disabled,
      label,
      error,
      onFocus,
    } = this.props;

    const selectClassNames: string = classNames('select-component', {
      'select-component_transparent': transparent,
    });

    const dropdownClassNames: string = classNames('select-component__dropdown', {
      'select-component__dropdown_transparent': transparent,
      'select-component__dropdown_disabled': disabled,
      'select-component__dropdown_label': label,
      'select-component__dropdown_error': error,
    });

    return (
      <div className={selectClassNames}>
        {
          label
            && <div className={'select-component__label'}>{label}</div>
        }

        <select
          className={dropdownClassNames}
          disabled={disabled}
          value={value}
          ref={this.setRef}
          onChange={this.onChange}
          onFocus={onFocus}
        >
         {placeholder && <option value={''} disabled>{placeholder}</option>}
         {this.options()}
        </select>

        {<BubbleError error={error} />}
      </div>
    );
  }

  private options = () => (
    this.props.options.map(({value, label}: ISelectOption) => (
      <option
        value={value}
        key={value}
      >
        {label}
      </option>
    ))
  )

  private setRef = (node) => {
    const {reference} = this.props;

    this.ref = node;

    isFunction(reference)
      && reference(node);
  };

  private onChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const {onChange, options} = this.props;
    const {value} = event.target;

    const selectedOption: ISelectOption = options
      .find((option: ISelectOption) => option.value === value);

    this.setState({value}, () => onChange(selectedOption));
  }
}
